import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { XCircle } from "lucide-react";

const COPY = {
  en: {
    title: "Payment cancelled",
    subtitle: "No charge was made. You can try again anytime.",
    back: "Back to home",
  },
  es: {
    title: "Pago cancelado",
    subtitle: "No se hizo ningún cargo. Puedes intentarlo cuando quieras.",
    back: "Volver al inicio",
  },
};

export default function PaymentCancel() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <div className="max-w-2xl mx-auto py-10" data-testid="payment-cancel-page">
      <div className="bg-white border-2 border-[#E4DDD3] rounded-3xl p-8 sm:p-10 text-center shadow-lg">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-[#707880] text-white flex items-center justify-center">
          <XCircle className="w-9 h-9" />
        </div>
        <h1 className="mt-5 text-2xl sm:text-3xl font-bold">{c.title}</h1>
        <p className="mt-3 text-[#4A525A]">{c.subtitle}</p>
        <Link to="/" data-testid="cancel-back-home" className="pod-focus mt-6 inline-flex bg-[#C85A32] hover:bg-[#B24C28] text-white font-bold py-3 px-6 rounded-xl">
          {c.back}
        </Link>
      </div>
    </div>
  );
}
